export default {"src":"/_next/static/media/capabilities.af42ff5c.svg","height":47,"width":46,"blurWidth":0,"blurHeight":0};